// 生产环境地址
const configProduction = {
  backendBaseUrl: 'https://api.yi-insurance.cn', // 后台地址
  NODE_ENV: 'production',
};
// uat环境地址
const configUat = {
  backendBaseUrl: 'https://api.tsbdev.top', // 后台地址
  NODE_ENV: 'development',
};
// 开发环境地址
const configDev = {
  backendBaseUrl: 'http://127.0.0.1:8000', // 后台地址
  NODE_ENV: 'development',
};
const config = () => {
  if (process.env.NODE_ENV === 'production') {
    return configProduction;
  } else if (process.env.NODE_ENV === 'uat') {
    return configUat;
  }
  return configDev;
};
export default config();



// WEBPACK FOOTER //
// ./src/lib/config.js